module.exports = __webpack_public_path__ + "img/account_300.6a5fa625.jpg";